import { render, staticRenderFns } from "./JdsTableCurrencyFooter.vue?vue&type=template&id=78fa3005&scoped=true&"
import script from "./JdsTableCurrencyFooter.vue?vue&type=script&lang=ts&"
export * from "./JdsTableCurrencyFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa3005",
  null
  
)

export default component.exports